<ra-modal
    [title]="(isEdit() ? 'document.edit.quote.discountModal.titleEdit' : 'document.edit.quote.discountModal.titleNew') | translate"
    [size]="'medium'"
    [disabled]="loading()"
    (close)="close.emit()">

    <div class="discount-body" [formGroup]="form">
        <!-- Tipo de desconto (editável também no modo edição) -->
        <div class="field">
            <span class="field-label">{{ 'document.edit.quote.discountModal.mode' | translate }}</span>
            <ra-select [model]="modeSelectModel" (selectedOption)="onModeSelect($event)" />
        </div>

        <!-- Valor do desconto -->
        <div class="field">
            <ra-input
                formControlName="value"
                [type]="valueInputType"
                [currencyCode]="currencyCode()"
                [locale]="locale()"
                [label]="valueLabel | translate"
                [showLimitCharacters]="false"
            />

            @if (form.controls.value.touched && form.controls.value.errors?.['max']) {
                <span class="field-error">{{ 'document.edit.quote.validation.percentMax' | translate }}</span>
            }
        </div>
    </div>

    <!-- Footer fixo -->
    <div class="discount-actions">
        <ra-button
            [label]="'common.cancel' | translate"
            [type]="'primary-outline'"
            [disabled]="loading()"
            (click)="close.emit()"
        />
        <ra-button
            [label]="'common.save' | translate"
            [type]="'primary'"
            [loading]="loading()"
            [disabled]="loading() || form.invalid"
            (click)="onSave()"
        />
    </div>
</ra-modal>
